export { EloMonduIcon } from './mondu-icon'
